class ProductQuickNav extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCarousel();
  }

  disconnectedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {}

  get slidesPerViewMobile() {
    return this.getAttribute('slides-per-view-mobile') || 2.5;
  }

  get slidesPerViewTablet() {
    return this.getAttribute('slides-per-view-tablet') || 3.5;
  }

  get slidesPerViewDesktop() {
    return this.getAttribute('slides-per-view-desktop') || 5.5;
  }

  get spaceBetween() {
    return this.getAttribute('space-between') || 30;
  }

  get loop() {
    return this.getAttribute('loop') === 'true' || false;
  }

  get initialSlide() {
    return Number(this.getAttribute('initial-slide')) || 0;
  }

  initCarousel() {
    const swiperContainer = this.querySelector('.swiper');
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: this.slidesPerViewMobile,
      spaceBetween: this.spaceBetween,
      loop: this.loop,
      initialSlide: this.initialSlide,
      direction: 'horizontal',
      allowTouchMove: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
    });
  }
}

customElements.define('product-quick-nav', ProductQuickNav);
